<script setup lang="ts">
import { helpers, required } from "@vuelidate/validators";
import { computed, reactive, ref, toRefs } from "vue";
import {
  FormInput,
  FormLabel,
  FormCheck,
  FormSelect
} from "../../../base-components/Form";
import Preview from "../../../base-components/Preview";
import { IOCAPOSConfig } from "@fixeduy/restaurantestypes";

interface Props {
  indice: number;
  pos: IOCAPOSConfig | null;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  (e: "actualizar", data: { indice: number; pos: IOCAPOSConfig }): void;
}>();

// const localesStore = useLocalesStore();

const formData = reactive({
  nombre: props.pos?.nombre ?? "",
  local: props.pos?.local ?? "",
  PosID: props.pos?.PosID ?? "",
  Branch: props.pos?.Branch ?? "1",
  ClientAppId: props.pos?.ClientAppId ?? "1",
  Plan: props.pos?.Plan ?? "0",
  imprime: props.pos?.imprime ?? true,
  taxRefund: props.pos?.taxRefund ?? "0"
});

const rules = {
  nombre: {
    required: helpers.withMessage(
      "El campo nombre no puede estar vacío",
      required
    )
  },
  local: {
    required: helpers.withMessage(
      "El campo local no puede estar vacío",
      required
    )
  },
  PosID: {
    required: helpers.withMessage(
      "El campo PosID no puede estar vacío",
      required
    )
  },
  Plan: {
    required: helpers.withMessage(
      "El campo Plan no puede estar vacío",
      required
    )
  },
  imprime: {
    required: helpers.withMessage(
      "El campo imprime no puede estar vacío",
      required
    )
  },
  taxRefund: {
    required: helpers.withMessage(
      "El campo devolución de impuestos no puede estar vacío",
      required
    )
  }
};

const actualizar = () => {
  const datos: IOCAPOSConfig = {
    nombre: formData.nombre,
    local: formData.local,
    PosID: formData.PosID,
    Plan: formData.Plan,
    Branch: formData.Branch,
    imprime: formData.imprime,
    ClientAppId: formData.ClientAppId,
    taxRefund: formData.taxRefund
  };
  emit("actualizar", { indice: props.indice, pos: datos });
};

const cuartaColumna = computed(() => {
  // return localesStore.localesActivos.length > 1;
});
</script>

<template>
  <Preview class="box mt-2">
    <div class="border">
      <div class="flex flex-row rounded-md w-full space-x-3">
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Nombre (interno Atiendo) </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.nombre"
                placeholder="Nombre"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> PosID (brindado por OCA) </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.PosID"
                placeholder="PosID"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Plan (brindado por OCA) </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.Plan"
                placeholder="Plan"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row rounded-md w-full space-x-4">
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Branch </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.Branch"
                placeholder="Branch"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> ClientAppId</FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.ClientAppId"
                placeholder="ClientAppId"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Local </FormLabel>
            </div>
            <div class="flex-1">
              <FormSelect
                v-model="formData.local"
                id="local"
                @change="actualizar"
              >
                <option value="" disabled>Local</option>

                <!-- <option
                  v-for="local in localesStore.localesActivos"
                  :key="local.id"
                  :value="local.id"
                >
                  {{ local.nombre }}
                </option> -->
              </FormSelect>
            </div>
          </div>
        </div>
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Impuestos</FormLabel>
            </div>
            <div class="flex-1">
              <FormSelect
                v-model="formData.taxRefund"
                id="taxRefund"
                @change="actualizar"
              >
                <option value="0">Sin devolución</option>
                <option value="1">IVA - Ley 19.210</option>
                <option value="2">IMESI - Ley 18.083</option>
                <option value="3">AFAM - Ley 18.910</option>
                <option value="4">IVA - Ley 17.934</option>
                <option value="5">IRPF - Ley 18.999</option>
              </FormSelect>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-1 p-3">
        <div class="flex">
          <div class="flex-none w-50 text-right pr-5 mt-2">
            <FormLabel>
              Pos imprime voucher (muy importante que este bien configurado por
              las reversas)</FormLabel
            >
          </div>
          <div class="flex-1">
            <FormCheck.Input
              id="checkbox-switch-1"
              type="checkbox"
              v-model="formData.imprime"
              @change="actualizar"
            />
          </div>
        </div>
      </div>
    </div>
  </Preview>
</template>
